//basic
import React from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from "../../../components/basic/input";
import CustomButton from "../../../components/basic/CustomButton";

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    ListItem,
    CircularProgress
} from "@material-ui/core";
import { DateTimePicker } from "material-ui-pickers";
import { IconButton, InputAdornment } from "@material-ui/core";
import CalendarToday from '@material-ui/icons/CalendarToday';

//style
import "./AddEditItem.scss";

//other libraries
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";

import moment from 'moment';
import 'moment/locale/sk';

//calendar
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';


const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
            disabled: {
                "&::before" : {
                    borderBottom: "1px solid #777777 !important"
                }
            }
        },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: "#FF7800",
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          // backgroundColor: lightBlue.A200,
          // color: 'white',
        },
      },
      MuiPickersClock: {
        pin: {
          backgroundColor: "#FF7800",
        },
      },
      MuiPickersClockPointer: {
        pointer: {
            backgroundColor: "#FF7800",
        },
        thumb: {
            backgroundColor: "#FF7800",
            borderColor: "#FF7800",
        }
      },
      MuiPickersClockNumber: {
        selected: {
          backgroundColor: "#FF7800",

        },
      },
      MuiPickersDay: {
        day: {
          color: "#777777",
        },
        selected: {
          backgroundColor: "#FF7800",
          '&:hover': {
            backgroundColor: "#FF7800",
          }
        },
        current: {
          color: "#777777"
        },
      },
      MuiPickersYear: {
        root: {
          color: "#777777",
          '&:hover': {
            color: "#FF7800",
          }
        },
        selected: {
          color: "#FF7800 !important",
          '&:hover': {
            color: "#FF7800",
          }
        },
      },
      MuiPickersModal: {
        dialogAction: {
          color: "#777777",
        },

      },
    },
  });

@inject("translate")
@inject("internal")
@observer
export default class AddEditItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parameterType: 0,
            loading: false,
            loadingBtn: false,
            published_from: moment(),
            published_until: moment().add(10,"y"),
            locale: 'sk',
            menu_position: this.props.typeMenu, // hlavne alebo spodne
            frontend_menu_type: "", // domov, produkt, clanok, kontakt
            production: false,
            category_id: "",
            content: "&nbsp;",
            is_external: false,
        };
    }

    componentDidMount() {
        let isEditMode = toJS(this.props.internal.actionEdit);
        if(isEditMode.edit) {
            this.setState({loading: true})
            this.loadDetailMenu(isEditMode.id)
        }

    }

    loadDetailMenu = async(idMenu) => {
        let load_data = await api({
            method:'get',
            url: `lists/frontend-menu/${idMenu}`,
            authorization: this.props.internal.user.access_token,

        })

        if(load_data.success === true) {

            this.setState({
                loading: false,
                published_from: load_data.data.data.published_from,
                published_until: load_data.data.data.published_until,
                production: load_data.data.data.production,
                menu_position: load_data.data.data.menu_position,
                frontend_menu_type: load_data.data.data.frontend_menu_type_id,
                content: load_data.data.data.content,
                category_id: load_data.data.data.category_id,
                is_external: load_data.data.data.is_external,
            }, () => {
                this.title.setValue(load_data.data.data.name)
                this.alias.setValue(load_data.data.data.alias)
                this.external_url.setValue(load_data.data.data.external_url)
                this.page_description.setValue(load_data.data.data.page_description !== null ? load_data.data.data.page_description : "")
                this.page_title.setValue(load_data.data.data.page_title !== null ? load_data.data.data.page_title : "")
            })
        }
    }

    handleChangeParameterType = event => {
        this.setState({ parameterType: event.target.value });
    };

    handleChangeParentType = event => {
        this.setState({frontend_menu_type: event.target.value})
    }

    action = () => {
        if(toJS(this.props.internal.actionEdit.edit)) {
            this.updateMenuItem()
        }
        else {
            this.createNewMenuItem()
        }
    };

    createNewMenuItem = async() => {
        this.setState({loadingBtn: true})
        let params = {
            name: this.title.state.value,
            alias: this.alias.state.value,
            external_url: this.external_url.state.value,
            menu_position: this.state.menu_position,
            frontend_menu_type_id: this.state.frontend_menu_type,
            published_from: moment(this.state.published_from).format("YYYY-MM-DD"),
            published_until: moment(this.state.published_until).format("YYYY-MM-DD"),
            shop_id: this.props.shop,
            page_title: this.page_title.state.value,
            page_description: this.page_description.state.value,
            production: this.state.production,
            is_external: this.state.is_external,
        }

        // produkt
        if(this.state.frontend_menu_type === 2) {
            params.category_id = this.state.category_id
        }
        // clanok - potrebne je vytvorit obsah
        else if(this.state.frontend_menu_type === 4) {
            params.content = this.state.content
        }

        let create_data = await api({
            method:'post',
            url: `lists/frontend-menu`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(create_data.success === false && create_data.status === 201) {
            this.props.internal.setSnackbar(create_data.data.message, true)
            this.props.setMenuPosition(this.state.menu_position)
            if(create_data.data.data.frontend_menu_type_id === 4) {
                this.props.onClose(true, create_data.data.data.id)
            }
            else {
                this.props.onClose(true)
            }

            this.setState({loadingBtn: false})
        }
        else{
            let resultError = ""
            for(let err in create_data.data.data.errors) {
                resultError += create_data.data.data.errors[err] + " "
            }
            this.props.internal.setSnackbar(resultError, true)
            this.setState({loadingBtn: false})
        }
    }

    updateMenuItem = async() => {
        let idMenu = toJS(this.props.internal.actionEdit.id)
        this.setState({loadingBtn: true})
        let params = {
            name: this.title.state.value,
            alias: this.alias.state.value,
            external_url: this.external_url.state.value,
            menu_position: this.state.menu_position,
            frontend_menu_type_id: this.state.frontend_menu_type,
            published_from: moment(this.state.published_from).format("YYYY-MM-DD"),
            published_until: moment(this.state.published_until).format("YYYY-MM-DD"),
            production: this.state.production,
            is_external: this.state.is_external,
            category_id: this.state.category_id,
            content: this.state.content,
            page_title: this.page_title.state.value,
            page_description: this.page_description.state.value,
        }

        let update_data = await api({
            method:'patch',
            url: `lists/frontend-menu/${idMenu}`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(update_data.success === true ) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
            this.setState({loadingBtn: false})
        }
        else{
            let resultError = ""
            for(let err in update_data.data.data.errors) {
                resultError += update_data.data.data.errors[err] + " "
            }
            this.props.internal.setSnackbar(resultError, true)
            this.setState({loadingBtn: false})
        }
    }

    handleDateChange = (type, date) => {
        if(type === "selectDateFrom") {
            this.setState({ published_from: date });
        }
        else {
            this.setState({ published_until: date });
        }

    };

    handleChangeType = menu_position => {
        this.setState({menu_position: menu_position.target.value})
    }

    handleChangeProductCategory = val => {
        this.setState({category_id: val.target.value})
    }

    handleChangeCheckbox = (event) => {
        this.setState({production: event.target.checked})
    }

    handleChangeIsExternal = (event) => {
      console.log('yes?')
        this.setState({is_external: event.target.checked})
    }

    timeout = null
    checkAlias = () => {
        if(!toJS(this.props.internal.actionEdit.edit)) {
            clearTimeout(this.timeout)
            this.timeout =  setTimeout(() => {
            this.suggestAlias()
            }, 500)
        }
    }

    suggestAlias = async(shop_id) => {
        if(this.title.state.value !== "") {
            let update_data = await api({
                method:'post',
                url: `lists/frontend-menu/suggest-alias`,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: this.title.state.value,
                    shop_id: this.props.shop
                }
            })
            this.alias.setValue(update_data.data.data.alias)
        }
        else {
            this.alias.setValue("")
        }
    }


    render() {
        const { published_from, published_until} = this.state;

        const { lists } = toJS(this.props.internal.dataForTable)

        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    paper: "addEditMenuItemDialog"
                }}
            >
                <DialogTitle id="form-dialog-title">
                    {this.props.title}
                </DialogTitle>
                {this.state.loading ?
                <DialogContent>
                    <CircularProgress className={'circular-progress'}/>
                </DialogContent>
                :
                <DialogContent>
                    <MuiThemeProvider theme={materialTheme}>
                    <CustomInput
                        ref={ref => (this.title = ref)}
                        text={this.props.translate.i18n.MODULES.MENU.TITLE}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        value=""
                        id={"title"}
                        className={"w-100"}
                        required
                        change={this.checkAlias}
                    />
                    <ListItem
                      dense
                      onChange={this.handleChangeIsExternal}
                      className={"list-item"}
                    >
                      <input
                        id={"is_external"}
                        type="checkbox"
                        value={"is_external"}
                        defaultChecked={
                          this.state.is_external
                        }
                      />
                      <label htmlFor={"is_external"}>
                        {this.props.translate.i18n.MODULES.MENU.IS_EXTERNAL}
                      </label>
                    </ListItem>
                    <CustomInput
                        ref={ref => (this.external_url = ref)}
                        text={this.props.translate.i18n.MODULES.MENU.EXTERNAL_URL}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        value=""
                        id={"external_url"}
                        className={`w-100 ${this.state.is_external ? '' : 'hidden'}`}
                        // disabled={!this.props.internal.actionEdit.edit}
                    />
                    <CustomInput
                        ref={ref => (this.alias = ref)}
                        text={this.props.translate.i18n.MODULES.MENU.ALIAS}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        value=""
                        id={"alias"}
                      className={`w-100 ${this.state.is_external ? 'hidden' : ''}`}
                        // disabled={!this.props.internal.actionEdit.edit}
                    />
                    <FormControl className="select-type w-100">
                        <InputLabel
                            htmlFor="menu-type"
                            className={"label-select-type"}
                            required
                        >
                            {this.props.translate.i18n.MODULES.MENU.MENU_TYPE}
                        </InputLabel>
                        <Select
                            classes={{
                                root: "select-menu-type-root"
                            }}
                            value={this.state.frontend_menu_type}
                            onChange={this.handleChangeParentType}
                            inputProps={{
                                name: "menu_type",
                                id: "menu-type"
                            }}
                        >
                            {lists.frontend_menu_types.map((frontend_menu_type, index) => {
                                return (
                                    <MenuItem key={frontend_menu_type.id} value={frontend_menu_type.id}>{this.props.translate.i18n.MODULES.MENU.MENU_TYPES[(frontend_menu_type.name).toUpperCase()]}</MenuItem>
                                )
                            })}

                        </Select>
                    </FormControl>
                    {/* ak je frontend_menu_type produkt */}
                    {this.state.frontend_menu_type === 2 ?
                    <FormControl className="select-type w-100">
                        <InputLabel
                            htmlFor="product-category"
                            className={"label-select-type"}
                        >
                            {this.props.translate.i18n.MODULES.MENU.CATEGORY}
                        </InputLabel>
                        <Select
                            classes={{
                                root: "select-menu-type-root"
                            }}
                            value={this.state.category_id}
                            // value={''}
                            onChange={this.handleChangeProductCategory}
                            inputProps={{
                                name: "product-category",
                                id: "product-category"
                            }}
                        >
                            {lists.categories.map((category, index)=> {
                                return (
                                    <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    :
                    null
                    }
                    <FormControl className="select-type w-100">
                        <InputLabel
                            htmlFor="menu-position"
                            className={"label-select-type"}
                        >
                            {this.props.translate.i18n.MODULES.MENU.MENU_POSITION_LABEL}
                        </InputLabel>
                        <Select
                            classes={{
                                root: "select-menu-position-root"
                            }}
                            value={this.state.menu_position}
                            onChange={this.handleChangeType}
                            inputProps={{
                                name: "menu_position",
                                id: "menu-position"
                            }}
                        >
                            <MenuItem value="top">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.MAIN}</MenuItem>
                            <MenuItem value="bot">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.BOTTOM}</MenuItem>
                        </Select>
                    </FormControl>
                    <CustomInput
                        ref={ref => (this.page_title = ref)}
                        text={this.props.translate.i18n.MODULES.MENU.PAGE_TITLE}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        value=""
                        id={"page_title"}
                        className={"w-100"}
                    />
                    <CustomInput
                        ref={ref => (this.page_description = ref)}
                        text={this.props.translate.i18n.MODULES.MENU.PAGE_DESCRIPTION}
                        // value={this.props.idCategory ? this.editCategory.name : ""}
                        value=""
                        id={"page_description"}
                        className={"w-100"}
                        multiline
                    />

                        <MuiPickersUtilsProvider utils={MomentUtils} locale={this.state.locale} moment={moment} >
                            <div className="date-picker">
                            <span>{this.props.translate.i18n.MODULES.MENU.PUBLISHED_FROM}</span>
                                <DateTimePicker
                                    okLabel={<span style={{color: "#FF7800"}}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                    cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                    autoOk
                                    ampm={false}
                                    showTabs={false}
                                    autoSubmit={false}
                                    allowKeyboardControl={false}
                                    labelFunc={date => (date ? date.format('DD.MM.YYYY HH:mm') : '')}
                                    // disableFuture
                                    // minDate={new Date("2018-01-01")}
                                    value={published_from}
                                    onChange={(date) => this.handleDateChange('selectDateFrom', date)}
                                    // helperText="Hardcoded helper text"
                                    // leftArrowIcon={<AlarmIcon />}
                                    // rightArrowIcon={<SnoozeIcon />}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarToday />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="date-picker" >
                                <span>{this.props.translate.i18n.MODULES.MENU.PUBLISHED_UNTIL}</span>
                                <DateTimePicker
                                    okLabel={<span style={{color: "#FF7800"}}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                                    cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                                    autoOk
                                    ampm={false}
                                    showTabs={false}
                                    autoSubmit={false}
                                    allowKeyboardControl={false}
                                    // disableFuture
                                    // minDate={new Date("2018-01-01")}
                                    value={published_until}
                                    onChange={(date) => this.handleDateChange('selectDateTo', date)}
                                    labelFunc={date => (date ? date.format('DD.MM.YYYY HH:mm') : '')}
                                    // helperText="Hardcoded helper text"
                                    // leftArrowIcon={<AlarmIcon />}
                                    // rightArrowIcon={<SnoozeIcon />}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarToday />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </MuiPickersUtilsProvider>
                    </MuiThemeProvider>
                    <ListItem
                        dense
                        onChange={this.handleChangeCheckbox}
                        className={"list-item"}
                    >
                        <input
                            id={"production"}
                            type="checkbox"
                            value={"production"}
                            defaultChecked={
                                this.state.production
                            }
                        />
                        <label htmlFor={"production"}>
                            {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                        </label>
                    </ListItem>
                </DialogContent>
                }
                <DialogActions>
                    <Button
                        onClick={() => this.props.onClose(false)}
                        className={"gray-text"}
                    >
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={"btn-white-bg"}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/menu/AddEditItem/AddEditItem.jsx